/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DateTime } from './DateTime';
export type IntegrationCreateBookingPayload = {
    eventRuleId: number;
    clientId: number;
    start: DateTime;
    end: DateTime;
    eventCategoryId?: number;
    locationSelection?: IntegrationCreateBookingPayload.locationSelection;
    personalMessage?: string;
};
export namespace IntegrationCreateBookingPayload {
    export enum locationSelection {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
}

